import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Clock } from "lucide-react";
import { useOrgAdminT } from "../i18n/context.js";
export function TasksPage() {
    const t = useOrgAdminT();
    return (_jsxs("div", { className: "flex flex-col items-center justify-center py-16 text-slate-400 dark:text-slate-500", children: [_jsx(Clock, { className: "h-10 w-10", strokeWidth: 1.5 }), _jsx("h2", { className: "mt-3 text-base font-semibold text-slate-600 dark:text-slate-300", children: t("tasks.title") }), _jsx("p", { className: "mt-1 text-sm", children: t("tasks.comingSoon") })] }));
}
//# sourceMappingURL=TasksPage.js.map